<template>
    <v-dialog v-model="dialog" max-width="610" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="py-8 px-11">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <v-form @submit.prevent="handleSubmit(save)">
                    <h2 class="text-center">Create Team</h2>

                    <ValidationProvider name="Name" rules="required|max:80" v-slot="{ errors }">
                        <v-text-field label="Name"
                                      v-model="team.name"
                                      class="mt-5"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-team'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider name="Teacher" rules="required" v-slot="{ errors }">
                        <v-select :items="teachers"
                                  label="Teacher"
                                  item-text="full_name"
                                  item-value="id"
                                  v-model="team.teacher_id"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-teacher'" size="15" class="mr-1"></svg>
                            </template>

                            <template v-slot:append>
                                <svg v-svg="'icon-select'" size="16"></svg>
                            </template>
                        </v-select>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider name="Stage" rules="required" v-slot="{ errors }">
                        <v-select :items="stages"
                                  label="Stage"
                                  item-text="name"
                                  item-value="id"
                                  v-model="team.stage"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-stage'" size="15" class="mr-1"></svg>
                            </template>

                            <template v-slot:append>
                                <svg v-svg="'icon-select'" size="16"></svg>
                            </template>
                        </v-select>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <v-card-actions class="d-flex justify-center mt-6">
                        <v-btn class="green white--text mr-4" type="submit" :loading="loadingRequest">Save</v-btn>
                        <v-btn class="transparent green--text ml-4" @click="dialog = false">Close</v-btn>
                    </v-card-actions>
                </v-form>
            </ValidationObserver>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data(){
            return {
                dialog: false,
                loadingRequest: false,
                team: {},
                teachers: [],
                stages: [],
            }
        },

        mounted() {
          this.getTeachers();
          this.getStages();
        },

        methods: {
            save() {
                this.loadingRequest = true;
                this.$apiAdmin('teams').create(this.team)
                    .then(() => {
                        this.team = {};
                        this.$refs.form.reset();
                        this.$parent.$emit('getTeams');
                        this.$store.dispatch('alert', {type: 1, message: 'Successfully created.'});
                    }).catch((err) => {
                    if (err.response.status === 422) console.log(err.response.data);
                }).finally(() => {
                    this.loadingRequest = false;
                    this.dialog = false;
                })
            },

            getTeachers(){
                this.$apiAdmin('users').get({params: {all: 1, teachers: 1}})
                    .then((res) => {
                        this.teachers = res.data.users;
                    })
            },

            getStages(){
                this.$apiAdmin('subjects').getFullSubject({params: {all: 1}}).then((res) => {
                    this.stages = res.data.courses;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/components/dialog";
</style>